module.exports = __webpack_public_path__ + "img/20211018.43be099d.gif";